module.exports = __webpack_public_path__ + "static/img/权限不足.286bc2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/权限不足.png
// module id = 1037
// module chunks = 1